import { FC } from 'react';
import { BRANDS_ABOUT_LABEL } from './model';
import './BrandsAboutComponent.scss';
import { VideoVimeoComponent } from '../../UI/VideoVimeoComponent/VideoVimeoComponent';

export const BrandsAboutComponent: FC = () => {
	return (
		<div className='brand-about-container'>
			<h2 className='section-title'>{BRANDS_ABOUT_LABEL.title}</h2>
			<div className='content-container'>
				<div className='text-container'>
					<h3 className='section-subtitle'>{BRANDS_ABOUT_LABEL.content_subititle}</h3>
					<p className='highlight-subtitle'>{BRANDS_ABOUT_LABEL.highlight_content}</p>
					<p className='section-content'>{BRANDS_ABOUT_LABEL.content1}</p>
					<p className='section-content'>
						{BRANDS_ABOUT_LABEL.content2}
						<a href={BRANDS_ABOUT_LABEL.linkContent} target='_blank' rel='noopener noreferrer'>
							{BRANDS_ABOUT_LABEL.linkText}
						</a>
						{BRANDS_ABOUT_LABEL.content3}
					</p>
				</div>
				<div className='video-mask'>
					<VideoVimeoComponent
						autoplay
						videoId={BRANDS_ABOUT_LABEL.videoLink}
						videoTitle=''
						hash={BRANDS_ABOUT_LABEL.videoHash}
					></VideoVimeoComponent>
				</div>
			</div>
		</div>
	);
};

export default BrandsAboutComponent;
